exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-alert-liquidacao/bra-alert-liquidacao.component.css
// module id = ../../../../../src/app/componentes/bra-alert-liquidacao/bra-alert-liquidacao.component.css
// module chunks = main